import React, { useReducer, useEffect } from "react";
import {
    MapContainer,
} from "react-leaflet";
import { useCookies } from "react-cookie";
import { reducer, initialState, Context } from '../../store/reducer';
import NormalHeader from '../../components/Header/normal';
import MapController from '../../components/MapController';
import Spot from '../../components/Spot/register';
import { mapConfig } from '../../config/env';
import { spotList } from "../../components/Spot/register/config";
import { tmptestAPI } from "../../utils/api";
import { tmpAPI } from "../../utils/api";
import { kashika3Options } from "../../components/Header/normal/kashika3config";
import MenuSpot from "../../components/Spot/menu/popup87";
import MapUpdate from "../../components/MapUpdate";
import Geocoder from "../../components/Geocoder";

const Layout = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    // eslint-disable-next-line
    const [cookies,setCookie,removeCookie] = useCookies(["spots"]);
    const spots = cookies.spots || [];
    useEffect(() => {
        kashika3Options.map(menu =>{
            menu.options.map(options => {
                if (options.type=='geojson') {
                    tmpAPI.get(options.url)
                        .then(res=>{
                            dispatch({
                                type: 'SET_DATA',
                                category: options.id,
                                payload: res.data
                            });
                        })
                } else if (options.severType == 'demo'){

                    // ファイルサーバーから取得する
                    tmpAPI.get(options.url)
                    .then(res=>{
                        dispatch({
                            type: 'SET_DATA',
                            category: options.id,
                            payload: res.data
                        });
                    })
                } else if (options.type == 'marker'){

                    // APIから取得する
                    tmptestAPI.get(options.url)
                    .then(res=>{
                        dispatch({
                            type: 'SET_DATA',
                            category: options.id,
                            payload: res.data
                        });
                    })
                }
            })
        })

        tmptestAPI.get(process.env.REACT_APP_MENU)
        .then(res=>{
            // console.log(res)
            dispatch({
                type: 'SET_MENU',
                payload: res.data
          });
        })
        
        // ロード完了後にチェック状態にしてマーカーを表示する。
        if (state["vis_87"]) {
            dispatch({
                type: 'TOGGLE_CHECKED',
                category: "vis_87"
            })
        }

    }, [])
    
    return (
        <Context.Provider value={{ state, dispatch }}>
            <NormalHeader />
            <main className="main">
                <div className="main-inner">
                    <MapContainer
                        tap={false}
                        id="map"
                        {...mapConfig}
                    >
                        <Geocoder/>
                        <MapUpdate />
                        <MapController />
                        {spots.map((spot, index) => (
                            state.registerMode ?  
                            <Spot
                                key={index.toString()}
                                index={index}
                                latitude={spot.latitude}
                                longitude={spot.longitude}
                                category={spot.category}
                                draggable={state.registerMode}
                            /> : state[spotList[spotList.findIndex(category => category.name == spot.category)].type] && 
                            <Spot
                                key={index.toString()}
                                index={index}
                                latitude={spot.latitude}
                                longitude={spot.longitude}
                                category={spot.category}
                                draggable={state.registerMode}
                            />
                        ))}
                        {kashika3Options.map(menu => {
                            return menu.options.map(options => {
                                if(options.type === 'marker'){
                                    
                                    /*
                                     * 汎用マーカー描画
                                     */
                                    
                                    if (state[options.id].checked && state[options.id].data.spots) {
                                        return state[options.id].data.spots.map((d, index) =>
                                          <MenuSpot
                                            key={index.toString()}
                                            option={options}
                                            spot={d}
                                            latitude={d[options.column_lat]}
                                            longitude={d[options.column_lng]}
                                            menu={options.label}
                                            draggable={false}
                                          />
                                        )
                                    }
                                    
                                }
                            })
                        })}
                        
                    </MapContainer>

                </div>
            </main>
        </Context.Provider>
    )
}

export default Layout;
